import axios from "@main/axios";
import {logger} from "@main/helpers/logger";
import publicationCard from "@partials/publication.handlebars";
import publicationCardInSlider from "@partials/publicationInSlider.handlebars";

let isInProgress = false;
let wrapper;

export async function getAndUpdatePublication(el, slider, url, size, year, month, day, page) {
    function createPublicationCard(data) {
        let infoPublication;
        const publicationContent = {
            publication: {
                href: data.HREF,
                image: data.IMAGE,
                text: data.TEXT,
                date: data.DATE,
                datetime: data.DATETIME,
            }
        }

        if (slider) {
            infoPublication = publicationCardInSlider(publicationContent);
        } else {
            infoPublication = publicationCard(publicationContent);
        }    

        wrapper.insertAdjacentHTML("beforeend", infoPublication);       
    }

    function updatePublications(data) {
        if (!data) {
            return;
        }
        
        isInProgress = false;

        data.forEach((publ) => {
            createPublicationCard(publ);
        });
    }

    if (!url || !el) {
        return false;
    }

    try {
        if (slider) {
            wrapper = el.querySelector(".swiper-wrapper");
            const isEnd = slider.el.hasAttribute("data-slider");

            if (isInProgress || isEnd) {
                return;
            }

            isInProgress = true;
            const params = {
                year,
                month,
                size,
                day,
                page,
            };

            const response = await axios.get(url, {params});
            
            if (page == 1) {        
                wrapper.innerHTML = "";
            }

            queueMicrotask(() => {
                updatePublications(response.data.data.publications);
            })            

            slider.update();

            return response.data.data;
        } else {
            wrapper = el.querySelector(".publications-list");

            isInProgress = true;
            const params = {
                year,
                month,
                size,
                day,                
                page,
            };

            const response = await axios.get(url, {params});

            wrapper.innerHTML = "";

            updatePublications(response.data.data.publications);

            return response.data.data;
        }
    } catch (e) {
        logger.log(e);
        alert("Что-то пошло не так...\nПопробуйте обновить страницу");
        return false;
    }
}
